import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import { SessionService } from "../../services/session.service";
import { environment } from "../../../environments/environment";
import Swal from "sweetalert2";
import { Md5 } from "ts-md5/dist/md5";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { UtilityService } from "src/app/services/utility.service";
import * as $ from "jquery";

@Component({
  selector: 'app-trackresult',
  templateUrl: './trackresult.component.html',
  styleUrls: ['./trackresult.component.css']
})
export class TrackresultComponent implements OnInit {
  apiUrl: string; 
  status: boolean = false;
  dtOptions: any = {};
  submitted = false; 
 
  outboundForm: FormGroup;
  appointmentForm: FormGroup;
  resultDetails: any;
  passportNumber: any;
  travelType: any;
  appointmentId: string;
  inboundForm: FormGroup;
  collectionCenters: any;
  lgas: any;

  constructor(private formBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private utility: UtilityService,
    private sess: SessionService,
    private spinnerService: Ng4LoadingSpinnerService
    ) { }


  ngOnInit() {
    this.initAppointmentForm()
  }

  initAppointmentForm(){
    this.appointmentForm = this.formBuilder.group({ 
      appointmentId: ["", [Validators.minLength(7), Validators.required,
      Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),Validators.maxLength(15)]],
    });
  }

  submitForm(formData){
    this.submitted = true

    if(this.appointmentForm.invalid){
     return  
    }

    this.trackResult()
    this.submitted =false
  }

  trackResult() {
    let obj = {}; 
    this.appointmentId = this.appointmentForm.get("appointmentId").value
      this.spinnerService.show(); 
        this.apiUrl =
          environment.AUTHAPIURL +
          "passenger-track-record/" +
          this.appointmentId;

        this.http.get<any>(this.apiUrl).subscribe((data) => {
          console.log("resultDetails: ", data);
          if (data.status == true) {
            this.resultDetails = data.response;
            
            this.spinnerService.hide();
            
              document.getElementById('loadResultModal').click()
            
          } else {
            Swal.fire({
              icon: "info",
              title: "Success",
              text: data.message,
              showConfirmButton: true,
              timer: 4000,
            }); 
            this.spinnerService.hide();
          }
        });
       
  }

  viewModal(modal){
    this.utility.showModal(modal)
  }

}
